import { z } from "zod";

export const emailAndPasswordValidationSchema = z
  .object({
    password: z
      .string()
      .min(1, { message: "Please Enter Your Password" })
      .min(8, { message: "Password should be at least 8 characters long" })
      .refine((val) => /[A-Za-z]/.test(val), {
        message: "Password must include at least one letter",
      })
      .refine((val) => /\d/.test(val), {
        message: "Password must include at least one number",
      })
      .refine((val) => /[!@#$%^&*(),.?":{}|<>]/.test(val), {
        message: "Password must include at least one special character",
      }),
    password_confirmation: z.string().min(8, {
      message: "Please confirm your password with 8 characters",
    }),
  })
  .refine((data) => data.password === data.password_confirmation, {
    message: "Passwords do not match",
    path: ["password_confirmation"], // This ensures the error is associated with the password_confirmation field
  });

export type EmailAndPasswordValidationSchemaType = z.infer<
  typeof emailAndPasswordValidationSchema
>;

export const twoFactorValidationSchema = z.object({
  country_code: z
    .string()
    .min(1, { message: "Please enter your country code" })
    .regex(/^\+\d+$/, { message: "Invalid country code format" }),
  phone_number: z
    .string()
    .min(1, { message: "Please enter your phone number" })
    .regex(/^\d{5,14}$/, { message: "Invalid phone number format" })
    .nullable(),
});

export type TwoFactorValidationSchemaType = z.infer<
  typeof twoFactorValidationSchema
>;
